import request from '../request.js'
// 导入用户：获取待选择人员信息（郑勇）
const getDeptsAndUsers = function (data) {
    return request({
        url: 'sysDept/getDeptsAndUsers',
        method: 'post',
        data
    })
}
// 导入用户：保存选择人员信息（郑勇）
const saveDeptsAndUsers = function (data) {
    return request({
        url: 'sysDept/saveDeptsAndUsers',
        method: 'post',
        data
    })
}
export {
    getDeptsAndUsers,
    saveDeptsAndUsers
}